export default "__VITE_ASSET__CKEPNzoc__"